class UpsellProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
    this.applyCSSIfNoScrollbar();
  }

  initializeElements() {
    this.elements = {
      variantTrigger: this.querySelectorAll('[data-quick-add-variant="submit"]'),
      variantInput: this.querySelector('[data-quick-add-selected-variant="selectedVariantInput"]'),
      quickAddTrigger: this.querySelectorAll('[data-quick-add="submit"]'),
      cartDrawerContainer: document.querySelector('.go-cart-drawer__container'),

      forwardButton: this.querySelector('[data-quick-add-variant="forward"]'),
      backButton: this.querySelector('[data-quick-add-variant="back"]'),
      scrollableList: this.querySelector('[data-quick-add-variant="list"]')
    };
  }

  setupEventListeners() {
    this.elements.variantTrigger.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const variantId = event.currentTarget.getAttribute('data-value');

        this.elements.variantInput.value = variantId;

        window.Moonbase.ajaxCart.handleAddToCartClick(event);
        this.scrollAjaxCartToTop();
      });
    });

    this.elements.quickAddTrigger.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        window.Moonbase.ajaxCart.handleAddToCartClick(event);
        this.scrollAjaxCartToTop();
      })
    })

    if (this.elements.forwardButton) {
      this.elements.forwardButton.addEventListener('click', this.scrollForward.bind(this));
    }

    if (this.elements.backButton) {
      this.elements.backButton.addEventListener('click', this.scrollBackward.bind(this));
    }
  }

  scrollAjaxCartToTop() {
    setTimeout(() => {
      this.elements.cartDrawerContainer.scroll({top:0, behavior:'smooth'});
    }, 1000);
  }

  applyCSSIfNoScrollbar() {
    const { scrollableList, backButton, forwardButton } = this.elements;
    if (!scrollableList) return;

    const { horizontal } = this.hasScrollbar(scrollableList);

    if (!horizontal) {
      scrollableList.style.justifyContent = "center";
      if (backButton) {
        backButton.style.display = 'none';
      }

      if (forwardButton) {
        forwardButton.style.display = 'none';
      }

    } else {
      scrollableList.style.justifyContent = "start";
      if (backButton) {
        backButton.style.display = 'flex';
      }

      if (forwardButton) {
        forwardButton.style.display = 'flex';
      }
    }
  }

  hasScrollbar(element) {
    return {
      horizontal: element.scrollWidth > element.clientWidth,
      vertical: element.scrollHeight > element.clientHeight
    };
  }

  scrollForward() {
    this.scrollListBy(45);
    setTimeout(() => this.toggleButtonState(), 500);
  }

  scrollBackward() {
    this.scrollListBy(-45);
    setTimeout(() => this.toggleButtonState(), 500);
  }

  scrollListBy(scrollStep) {
    const list = this.elements.scrollableList;
    list.scrollBy({ left: scrollStep, behavior: 'smooth' });
  }

  toggleButtonState() {
    const { scrollableList, backButton, forwardButton } = this.elements;
    if (!scrollableList || !backButton || !forwardButton) return;

    const scrollLeft = scrollableList.scrollLeft;
    const maxScrollLeft = scrollableList.scrollWidth - scrollableList.clientWidth;

    if (scrollLeft <= 1) {
      backButton.classList.add('disabled');
      backButton.setAttribute('disabled', 'true');
    } else {
      backButton.classList.remove('disabled');
      backButton.removeAttribute('disabled');
    }

    if (scrollLeft >= maxScrollLeft - 1) {
      forwardButton.classList.add('disabled');
      forwardButton.setAttribute('disabled', 'true');
    } else {
      forwardButton.classList.remove('disabled');
      forwardButton.removeAttribute('disabled');
    }
  }
}

customElements.define('upsell-product-card', UpsellProductCard);